import { useNavigate } from "react-router-dom";

export default function VerificarUsuarioIngresado() {
    const navigate = useNavigate();
    fetch("/api/usuario/usuario", {
        headers: { "Content-Type": "application/json" },
        credentials: "include"
    })
        .then(responseUsuario => {
            if (responseUsuario.ok) return responseUsuario.json();
            navigate("/login");
        })
        .then(data => {
            if (data.status === "OK") {
                navigate("/contacto");
            }
        });
}